var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[_c('el-row',{staticClass:"common-row"},[_c('el-col',{staticClass:"common-col-left",attrs:{"span":19,"xs":{ span: 24 }}},[_c('router-view')],1),_c('el-col',{staticClass:"common-col-right",attrs:{"span":5,"xs":{ span: 24 }}},[_c('div',{staticClass:"right-content-wrapper"})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }